import { render, staticRenderFns } from "./HosContact.vue?vue&type=template&id=be570d98&scoped=true"
import script from "./HosContact.vue?vue&type=script&lang=js"
export * from "./HosContact.vue?vue&type=script&lang=js"
import style0 from "./HosContact.vue?vue&type=style&index=0&id=be570d98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be570d98",
  null
  
)

export default component.exports